import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationControlService } from '../../services/configuration/configurationControl.service';
import { ActivatedRoute } from "@angular/router";
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { NavigateDemoGuard } from '../../guards/navigateDemo.guard'
import { CONFIG } from '../../constants/constants';
import { GlobalParametersPlexiDTO } from '../../model/GlobalParametersPlexiDTO';
import { LogElectronService } from '../../services/logElectron/log-electron.service';
import { LOG_EVENT, LOG_LEVEL } from '../../model/eLogElectron';
import { DateServerService } from '../../services/dateServerService/date-server.service';
import { LtiService } from '../../services/LTI/lti.service';
import { Mask, MaskService } from '../../services/mask/mask.service';




@Component({
  selector: 'app-init-app',
  templateUrl: './init-app.component.html',
  styleUrls: ['./init-app.component.css']
})
export class InitAppComponent implements OnInit {


  constructor(private _router: Router,
    private _activateRoute: ActivatedRoute,
    private _configurationService: ConfigurationService,
    private _configurationControlService: ConfigurationControlService,
    private _navigateDemoGuard: NavigateDemoGuard,
    private _logElectronService: LogElectronService,
    private _dateServerService: DateServerService,
    private _ltiService: LtiService,
    private _maskService: MaskService
  ) {

  }

  ngOnInit() {
    //this._configurationService.inhabilitarBotonAtras();
    this.consultarConfiguracionDemo();
    this._logElectronService.saveLog(LOG_LEVEL.INFO, LOG_EVENT.E_LOAD, "")

    this._activateRoute.queryParams.subscribe(params => {
      if (params.sumadiData) {
        console.log("SUMADIDATA =>")
        console.log(params.sumadiData);
        this._maskService.setMask(Mask.fullPageMask, true);
        this._ltiService.sumadiData = params.sumadiData;
      }
      if (params.sumadiData && params.assessment_id) {
        console.log("SUMADIDATA =>")
        console.log(params.sumadiData);
        console.log("assessment_id =>")
        console.log(params.assessment_id);
        this._maskService.setMask(Mask.fullPageMask, true);
        this._ltiService.idSessionStart = params.assessment_id;
      }
    });
  }

  public consultarConfiguracionDemo() {
    let self = this;
    if (CONFIG.ONLINE) {
      this._configurationService.getGlobalConfiguration().then(({ showDemo, showCaptcha, dateServer, tamFile, timeoutService, reintentosServiceLambda }: GlobalParametersPlexiDTO) => {
        self._navigateDemoGuard.activateDemo = showDemo;
        this._configurationControlService.showCaptcha = showCaptcha;
        this._configurationControlService.tamFile =  Number(tamFile);
        this._configurationControlService.timeoutService = timeoutService*1000;
        this._configurationControlService.reintentosServiceLambda = reintentosServiceLambda;
        
        self._dateServerService.setDateServer(dateServer);
        self.loadPage();
      })
    } else {
      this._navigateDemoGuard.activateDemo = true
      this._configurationControlService.showCaptcha = true;
      this._router.navigate(['/login']);
      this._configurationControlService.ambiente = "produccion";
    }

  }

  public loadPage() {
    let self = this;
    if (this._navigateDemoGuard.activateDemo) {
      if (this._configurationControlService.urlActual == undefined || this._configurationControlService.urlActual == "/login") {
        this._router.navigate(['/demo']);
        this._configurationControlService.ambiente = "demo";

      } else if (this._configurationControlService.urlActual == "/preIcfes") {
        this._router.navigate([this._configurationControlService.urlActual]);
        this._configurationControlService.ambiente = "preIcfes";
      } else if (this._configurationControlService.urlActual == "/demo") {
        this._router.navigate([this._configurationControlService.urlActual]);
        this._configurationControlService.ambiente = "demo";
      }
    } else {
      this._navigateDemoGuard.activateDemo = true
      this._router.navigate(['/login']);
      this._configurationControlService.ambiente = "produccion";
    }
  }
}
